// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSignInStyles } from "@stoneage/Overrides/Widgets/Common/HeaderSignIn";
import IconUser from "@stoneage/XDL/Icons/IconUser";
import { css } from "styled-components";

headerSignInStyles.headerClickable = {
    icon: {
        src: IconUser,
    },
};

headerSignInStyles.myAccountTooltip = {
    tooltipContent: {
        css: css`
            padding: 12px;
            width: 412px;
            max-width: 412px;
            border-radius: 0;
        `,
    },
};

headerSignInStyles.signInTooltip = {
    tooltipContent: {
        css: css`
            padding: 12px;
            width: 312px;
            max-width: 312px;
            border-radius: 0;
        `,
    },
};
